import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { logout, setAuth, getRiskScore } from '../reducers/userReducer';
import { handleError } from './helper';
import { isJwtExpired } from 'jwt-check-expiration';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export const nonProtectedRoute = [
  "/login",
  "/signup",
  "/error-test",
  "/condition",
  "/",
  "/auth",
  "/condition2",
  "/support",
  "/about-us",
  "/privacy-policy",
  "/tnc",
  "/link/phone",
  "/.well-known/assetlinks.json",
];


const useAuthStatus = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  useEffect(() => {
    let isMounted = true;
    const checkAuthStatus = async () => {
      let token = localStorage.getItem('token');
      const refreshToken = localStorage.getItem('refreshToken');
      if (!token || !refreshToken || isJwtExpired(token) && isJwtExpired(refreshToken)) {
        handleLogout();
        return;
      }

      try {
        dispatch(getRiskScore());
        if (isMounted) {
          dispatch(setAuth(true));
          setError(null);
        }
      } catch (err) {
        handleError(err);
        handleLogout();
        handleAuthError(err);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };
    checkAuthStatus();

    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  const handleLogout = () => {
    dispatch(setAuth(false));
    setLoading(false);
    dispatch(logout());
  };

  const handleAuthError = (err) => {
    if (err.response?.status === 401) {
      setError('Unauthorized');
      dispatch(logout());
      toast.error('Authentication failed. Please login again.');
    } else {
      setError(err.message);
      toast.error(err.message || 'An error occurred. Please try again.');
    }
  };

  return { loading, error };
};

export default useAuthStatus;
